import React, { Component } from "react";
import { Container, Card, Button } from "react-bootstrap";

import CardWithImageComponent from "../components/CardWithImageComponent.js";
import { applyNavigationEffect } from "../effects/NavigationEffect.js";

class Home extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    applyNavigationEffect();
  }

  render() {
    return (
      <div id="home" className="webpage">
        <div id="small-header">
          <h1>Burgverein Hohenfels e.V.</h1>
          <h3>Willkommen auf unserer Website</h3>
        </div>

        <div id="laufzeileQuestions" className="cursor-pointer-large">
          <a href="/85fragen">
            <img
              id="homepageQuestionsLogo"
              src="/assets/images/logo_85_fragen.png"
              alt="85fragen"
            />
          </a>
        </div>

        <Container>
          <CardWithImageComponent
            id="logo"
            className="card-with-image"
            header="Unser Vereinslogo"
            image="/assets/images/general_images/logo-transparent.png"
            text={<a href="/verein/logo">»Zur Beschreibung«</a>}
          />
         
          <CardWithImageComponent
            id="Mittsommernacht2025"
            className="card-with-image"
            header=""
            image="/assets/images/mittsommernacht/2026/sommernacht_01.jpg"
            text={<a href="/mittsommernacht">»Mehr Informationen«</a>}
          />
          
          <Card>
            <Card.Header className="small-h1">
              <a href="/freizeit/sonderveranstaltungen">Aktuelle Termine</a>
            </Card.Header>
            <Card.Body>
              <ul>
                <li>
                  22.06.2026 - Festzug 775 Feier Holzhausen
                </li>
                <li>
                  08.08.2026 - Mittsommernacht
                </li>
                <li>
                  23.08.2026 - Markttreiben Damshausen
                </li>
                <li>
                  13.09.2026 - Tag des offenen Denkmals
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}

export default Home;
